export const platform = process.env.PLATFORM ?? 'electron';

export const isDesktop = platform === 'tauri' || platform === 'electron';
